// WB presentation only; redemption requests and stored source instructions stay intact.
export const isWbCodeOrder = (orders, type) => type === 'code' && /^WB-\d+$/.test(String(orders?.orderNumber || ''))
export function wbCodeInstruction(html) {
  return String(html || '')
    .replace(/<a\b[^>]*href=["'][^"']*market\.yandex\.ru[^"']*["'][^>]*>[\s\S]*?<\/a>/gi, 'чат своего заказа на Wildberries')
    .replace(/на [«"“]?Яндекс[ -]Маркете[»"”]?/gi, 'на Wildberries')
    .replace(/Яндекс[ -]Маркет(?:е|а)?/gi, 'Wildberries')
}
